import { __decorate } from "tslib";
import OnlinePBXService from '@/Integrations/VoIP/onlinepbx';
import { Component, Mixins } from 'vue-property-decorator';
import { mapActions, mapGetters, mapState } from 'vuex';
import CompanyMixin from '../mixins-ts';
let OnlinePBXIntegrationComponent = class OnlinePBXIntegrationComponent extends Mixins(CompanyMixin) {
    domain = '';
    domainValid = null;
    domainErrorDescription = null;
    apiKey = '';
    isSaving;
    generalError = false;
    isChecking = false;
    saveIntegration;
    fetchIntegration;
    findIntegrationFromStore;
    hiddenAPIKey = '';
    get saveDisabled() { return this.isSaving && this.isChecking; }
    created() {
        this.fetchIntegration({ query: { companyId: this.company.id }, paginate: false });
    }
    get integrations() {
        const companyIntegrations = this.findIntegrationFromStore({ query: { companyId: this.company.id } });
        const integrations = companyIntegrations.data[0];
        if (!integrations || !integrations.onlinePBX)
            return null;
        this.domain = integrations.onlinePBX.domain;
        this.hiddenAPIKey = integrations.onlinePBX.apiKey;
        this.apiKey = '*'.repeat(integrations.onlinePBX.apiKey.length);
        return integrations;
    }
    async save() {
        this.generalError = false;
        this.verifyDomain();
        if (!this.domainValid)
            return;
        const apiKey = new RegExp("^[\\*]+$").test(this.apiKey) ? this.hiddenAPIKey : this.apiKey;
        const onlinePBX = {
            domain: this.domain,
            apiKey,
        };
        this.isChecking = true;
        const onlinePBXService = OnlinePBXService.getInstance(this.domain, apiKey);
        const authSuccess = await onlinePBXService.authorize().finally(() => this.isChecking = false);
        if (authSuccess)
            this.saveIntegration({
                companyId: this.company.id,
                onlinePBX,
            }).then(() => this.$toasted.global.success({
                message: this.$t('Integration saved successfully').toString(),
            }));
        else
            this.generalError = true;
    }
    logout() {
        this.saveIntegration({
            companyId: this.company.id,
            onlinePBX: null,
        }).then(() => this.$toasted.global.success({
            message: this.$t('Logged out successfully').toString(),
        }));
        this.domain = '';
        this.apiKey = '';
        this.hiddenAPIKey = '';
    }
    verifyDomain() {
        const isValid = this.domain.endsWith('.onpbx.ru');
        this.domainValid = isValid;
        this.domainErrorDescription = this.$t('Domain should end with .onpbx.ru').toString();
    }
};
OnlinePBXIntegrationComponent = __decorate([
    Component({
        computed: {
            ...mapState('company', { isSaving: 'isPatchPending' }),
            ...mapGetters('integrations', { findIntegrationFromStore: 'find' }),
        },
        methods: {
            ...mapActions('integrations', { saveIntegration: 'create', fetchIntegration: 'find' }),
        }
    })
], OnlinePBXIntegrationComponent);
export default OnlinePBXIntegrationComponent;
